/*eslint-disable */
import React, {useState} from "react";
import {RouteComponentProps} from "react-router";
import OurVisionStatmentWidget from "../../components/OurVisionStatementWidgets";
import useBasePage from "../../hooks/useBasePage";
import {usePageDataHook, useTrackingHook} from "../../hooks/utility";
import {GlobalLayoutPropsInterface} from "../../types";
import * as actions from "./actions";

interface Props extends RouteComponentProps {
    globalLayoutProps: GlobalLayoutPropsInterface;
}

const OurVisionStatementPage: React.FC<Props> = (props) => {
    const {location, globalLayoutProps} = props;
    const {pageName} = globalLayoutProps;
    const [showContentLoader, setContentLoaderStatus] = useState(false);

    useBasePage(location, globalLayoutProps);

    const pageDataHookObj = {
        reduxBucketName: globalLayoutProps.reduxBucketName,
        pageData: null,
        setContentLoaderStatus,
        location,
        api: actions.fetchInitialData,
        actions,
        startFromTop: true,
    };
    usePageDataHook(pageDataHookObj);

    useTrackingHook({
        pageName,
        pageData: null,
        isLoaderActive: showContentLoader,
    });
    return <OurVisionStatmentWidget />;
};

export default OurVisionStatementPage;
